import {
  AuthFlowId,
  AuthStepDefinition,
  AuthStepId,
  AuthStepRoute,
  AuthTransitionKey,
} from '../../models/auth-flow.models';

export const PVZ_LINK_STEP: AuthStepDefinition = {
  id: AuthStepId.ENTER_ON_PVZ_LINK,
  route: AuthStepRoute.Link,
  back: null,
  showLegalFooter: true,
  next: {
    [AuthFlowId.Pvz]: {
      [AuthTransitionKey.PvzPincode]: AuthStepId.ENTER_PINCODE,
      [AuthTransitionKey.PvzSubstitute]:
        AuthStepId.ENTER_ON_PVZ_LINK_UNKNOWN_USER,
    },
  },
};
